import { Box, Button, Card, CardBody, Container, Text, VStack } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRazorpay } from "react-razorpay"; 
import { useEffect } from "react"; 
import { useOrders } from "../../providers/OrderProvider";
import { useAuth } from "../../providers/AuthProvider";

export default function PayForOrder() {

    const { error, isLoading, Razorpay } = useRazorpay();
    const { user } = useAuth();
    const { updateOrderPayment } = useOrders();

    const { state } = useLocation();
    const navigate = useNavigate();

    console.log(state);

    const handlePayment = () => {
        const options = {
            key: "rzp_live_uX97L4SrT3deBx",
            amount: state.total * 100, // Amount in paise
            currency: "INR",
            name: "Vocalthread",
            description: "Vocalthread Payment",
            // order_id: state.id, // Generate order_id on server
            handler: async (response) => {
                console.log(response);
                // alert("Payment Successful!");
                // sample response 
                // {razorpay_payment_id: 'pay_QH90189oOqCr6t'}razorpay_payment_id: "pay_QH90189oOqCr6t"[[Prototype]]: Object

                await updateOrderPayment(state.id, response.razorpay_payment_id);
                // toast.success("Payment Successful!");
                navigate("/orders");
            },
            prefill: {
                name: user.name,
                // email: user.email,
                // contact: user.phone,
            },
            theme: {
                // color: "#F37254",
            },
        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();
    };

    useEffect(() => {
        if (state.status === "created" || state.status === "payment_pending") {
            setTimeout(() => {
                handlePayment();
            }, 1000);
            return;
        }
    }, [state.status]);

    return (
        <Container my='6' minH='80vh'>

            {error && <Text color='red'>{error}</Text>}

            {isLoading && <Text>Loading...</Text>}

            <Text className='customFont' as='h1' fontWeight='bold' fontSize='2xl' mb='2'>Pay for Order</Text>

            <Card>
                <CardBody as={VStack} spacing={4} w='100%' align='start'>
                    <Text>Order ID : {state.id}</Text>
                    <Text>Total Amount : ₹{state.total}</Text>
                    <Text>Order Date : {state.created_at}</Text>
                    <Text>Order Status : {state.status}</Text>

                    <Box p='2' border='1px solid #000' borderRadius='md'>
                        <Text>If the payment is not successful. You can go to My orders and try again.</Text>
                    </Box>

                    <Button colorScheme="primary" onClick={handlePayment}>Make Payment</Button>

                </CardBody>
            </Card>
        </Container>
    );
}
